Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTopSuggestions = exports.withClickIds = exports.getCompositeAggsQuery = exports.getAggsQuery = exports.extractQueryFromDefaultQuery = exports.updateInternalQuery = exports.getSearchState = exports.getOptionsFromQuery = exports.parseHits = exports.handleA11yAction = exports.getInnerKey = exports.getClassName = exports.checkSomePropChange = exports.checkPropChange = exports.updateDefaultQuery = exports.updateCustomQuery = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.isEqual = isEqual;
exports.debounce = debounce;
exports.getQueryOptions = getQueryOptions;
exports.buildQuery = buildQuery;
exports.pushToAndClause = pushToAndClause;
exports.checkValueChange = checkValueChange;
exports.getAggsOrder = getAggsOrder;
exports.formatDate = formatDate;
exports.getResultStats = getResultStats;
exports.handleOnSuggestions = handleOnSuggestions;

var _dateFormats = require('./dateFormats');

var _dateFormats2 = _interopRequireDefault(_dateFormats);

var _suggestions = require('./suggestions');

var _suggestions2 = _interopRequireDefault(_suggestions);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var updateCustomQuery = exports.updateCustomQuery = function updateCustomQuery(componentId, props, value) {
  if (props.customQuery && typeof props.customQuery === 'function') {
    props.setCustomQuery(componentId, props.customQuery(value, props));
  }
};

var updateDefaultQuery = exports.updateDefaultQuery = function updateDefaultQuery(componentId, props, value) {
  if (props.defaultQuery && typeof props.defaultQuery === 'function') {
    props.setDefaultQuery(componentId, props.defaultQuery(value, props));
  }
};

function isEqual(x, y) {
  if (x === y) return true;
  if (!(x instanceof Object) || !(y instanceof Object)) return false;
  if (x.constructor !== y.constructor) return false;

  for (var p in x) {
    if (!x.hasOwnProperty(p)) continue;
    if (!y.hasOwnProperty(p)) return false;
    if (x[p] === y[p]) continue;
    if (typeof x[p] !== 'object') return false;
    if (!isEqual(x[p], y[p])) return false;
  }

  for (var _p in y) {
    if (y.hasOwnProperty(_p) && !x.hasOwnProperty(_p)) return false;
  }

  return true;
}

function debounce(callback, wait) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
  var timeout = null;
  var callbackArgs = null;

  var later = function later() {
    return callback.apply(context, callbackArgs);
  };

  return function debouncedFunction() {
    callbackArgs = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

function getQueryOptions(props) {
  var options = {};

  if (props.size !== undefined) {
    options.size = props.size;
  }

  if (props.includeFields || props.excludeFields) {
    var source = {};

    if (props.includeFields) {
      source.includes = props.includeFields;
    }

    if (props.excludeFields) {
      source.excludes = props.excludeFields;
    }

    options._source = source;
  }

  return options;
}

function getOperation(conjunction) {
  if (conjunction === 'and') {
    return 'must';
  }

  if (conjunction === 'or') {
    return 'should';
  }

  return 'must_not';
}

function createBoolQuery(operation, query) {
  var resultQuery = null;

  if (Array.isArray(query) && query.length || !Array.isArray(query) && query) {
    resultQuery = {
      bool: _defineProperty({}, operation, query)
    };
  }

  if (operation === 'should' && resultQuery) {
    resultQuery = {
      bool: _extends({}, resultQuery.bool, {
        minimum_should_match: 1
      })
    };
  }

  return resultQuery;
}

function getQuery(react, queryList) {
  var query = [];
  Object.keys(react).forEach(function (conjunction) {
    if (Array.isArray(react[conjunction])) {
      var operation = getOperation(conjunction);
      var queryArr = react[conjunction].map(function (comp) {
        if (typeof comp !== 'string') {
          return getQuery(comp, queryList);
        } else if (comp in queryList) {
          return queryList[comp];
        }

        return null;
      }).filter(function (item) {
        return !!item;
      });
      var boolQuery = createBoolQuery(operation, queryArr);

      if (boolQuery) {
        query = [].concat(_toConsumableArray(query), [boolQuery]);
      }
    } else if (typeof react[conjunction] === 'string') {
      var _operation = getOperation(conjunction);

      var _boolQuery = createBoolQuery(_operation, queryList[react[conjunction]]);

      if (_boolQuery) {
        query = [].concat(_toConsumableArray(query), [_boolQuery]);
      }
    } else if (typeof react[conjunction] === 'object' && react[conjunction] !== null) {
      var _boolQuery2 = getQuery(react[conjunction], queryList);

      if (_boolQuery2) {
        query = [].concat(_toConsumableArray(query), [_boolQuery2]);
      }
    }
  });

  if (Array.isArray(query) && query.length) {
    return {
      bool: {
        must: query
      }
    };
  }

  if (query && Object.keys(query).length) {
    return query;
  }

  return null;
}

function getExternalQueryOptions(react, options, component) {
  var queryOptions = {};
  Object.keys(react).forEach(function (conjunction) {
    if (Array.isArray(react[conjunction])) {
      react[conjunction].forEach(function (comp) {
        if (options[comp]) {
          queryOptions = _extends({}, queryOptions, options[comp]);
        }
      });
    } else if (typeof react[conjunction] === 'string') {
      if (options[react[conjunction]]) {
        queryOptions = _extends({}, queryOptions, options[react[conjunction]]);
      }
    } else if (typeof react[conjunction] === 'object' && react[conjunction] !== null && !Array.isArray(react[conjunction])) {
      queryOptions = _extends({}, queryOptions, getExternalQueryOptions(react[conjunction], options));
    }
  });

  if (options[component]) {
    queryOptions = _extends({}, queryOptions, options[component]);
  }

  return queryOptions;
}

function buildQuery(component, dependencyTree, queryList, queryOptions) {
  var queryObj = null;
  var options = null;

  if (component in dependencyTree) {
    queryObj = getQuery(dependencyTree[component], queryList);
    options = getExternalQueryOptions(dependencyTree[component], queryOptions, component);
  }

  return {
    queryObj: queryObj,
    options: options
  };
}

function pushToAndClause(reactProp, component) {
  var react = _extends({}, reactProp);

  if (react.and) {
    if (Array.isArray(react.and)) {
      react.and = [].concat(_toConsumableArray(react.and), [component]);
      return react;
    } else if (typeof react.and === 'string') {
      react.and = [react.and, component];
      return react;
    }

    react.and = pushToAndClause(react.and, component);
    return react;
  }

  return _extends({}, react, {
    and: component
  });
}

function checkValueChange(componentId, value, beforeValueChange, performUpdate) {
  var selectedValue = value;

  if (Array.isArray(value) && !value.length) {
    selectedValue = null;
  }

  var handleError = function handleError(e) {
    console.warn(componentId + ' - beforeValueChange rejected the promise with ', e);
  };

  if (beforeValueChange) {
    try {
      var promise = beforeValueChange(selectedValue);

      if (promise instanceof Promise) {
        promise.then(performUpdate).catch(handleError);
      } else {
        performUpdate();
      }
    } catch (e) {
      handleError(e);
    }
  } else {
    performUpdate();
  }
}

function getAggsOrder(sortBy) {
  if (sortBy === 'count') {
    return {
      _count: 'desc'
    };
  }

  return {
    _term: sortBy
  };
}

var checkPropChange = exports.checkPropChange = function checkPropChange(prevProp, nextProp, callback) {
  if (!isEqual(prevProp, nextProp)) {
    callback();
    return true;
  }

  return false;
};

var checkSomePropChange = exports.checkSomePropChange = function checkSomePropChange() {
  var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var propsList = arguments[2];
  var callback = arguments[3];
  propsList.some(function (prop) {
    return checkPropChange(prevProps[prop], nextProps[prop], callback);
  });
};

var getClassName = exports.getClassName = function getClassName(classMap, component) {
  return classMap && classMap[component] || '';
};

var getInnerKey = exports.getInnerKey = function getInnerKey(obj, key) {
  return obj && obj[key] || {};
};

var handleA11yAction = exports.handleA11yAction = function handleA11yAction(e, callback) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback();
  }
};

var highlightResults = function highlightResults(result) {
  var data = _extends({}, result);

  if (data.highlight) {
    Object.keys(data.highlight).forEach(function (highlightItem) {
      var highlightValue = data.highlight[highlightItem][0];
      data._source = _extends({}, data._source, _defineProperty({}, highlightItem, highlightValue));
    });
  }

  return data;
};

var parseHits = exports.parseHits = function parseHits(hits) {
  var showHighlighted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var results = null;

  if (hits) {
    results = [].concat(_toConsumableArray(hits)).map(function (item) {
      var streamProps = {};

      if (item._updated) {
        streamProps._updated = item._updated;
      } else if (item._deleted) {
        streamProps._deleted = item._deleted;
      }

      var data = _extends({}, item);

      if (showHighlighted) data = highlightResults(item);
      var result = Object.keys(data).filter(function (key) {
        return key !== '_source';
      }).reduce(function (obj, key) {
        obj[key] = data[key];
        return obj;
      }, _extends({
        highlight: data.highlight || {}
      }, data._source, streamProps));
      return result;
    });
  }

  return results;
};

function formatDate(date, props) {
  if (props.parseDate) {
    return props.parseDate(date, props);
  }

  switch (props.queryFormat) {
    case 'epoch_millis':
      return date.getTime();

    case 'epoch_seconds':
      return Math.floor(date.getTime() / 1000);

    default:
      {
        if (_dateFormats2.default[props.queryFormat]) {
          return date.toString(_dateFormats2.default[props.queryFormat]);
        }

        return date.getTime();
      }
  }
}

var getOptionsFromQuery = function getOptionsFromQuery() {
  var customQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (customQuery) {
    var query = customQuery.query,
        rest = _objectWithoutProperties(customQuery, ['query']);

    return Object.keys(rest).length ? rest : null;
  }

  return null;
};

exports.getOptionsFromQuery = getOptionsFromQuery;

function computeResultStats(hits, searchState, promotedResults) {
  Object.keys(hits).forEach(function (componentId) {
    var _ref = hits[componentId] || {},
        hidden = _ref.hidden,
        total = _ref.total,
        time = _ref.time;

    searchState[componentId] = _extends({}, searchState[componentId], {
      resultStats: _extends({}, searchState[componentId].resultStats, {
        numberOfResults: total,
        time: time,
        promoted: promotedResults[componentId] && promotedResults[componentId].length,
        hidden: hidden || 0
      })
    });
  });
}

var getSearchState = exports.getSearchState = function getSearchState() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forHeaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var selectedValues = state.selectedValues,
      queryLog = state.queryLog,
      dependencyTree = state.dependencyTree,
      props = state.props,
      hits = state.hits,
      aggregations = state.aggregations,
      isLoading = state.isLoading,
      error = state.error,
      promotedResults = state.promotedResults,
      settings = state.settings,
      customData = state.customData,
      rawData = state.rawData;
  var searchState = {};

  var populateState = function populateState() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = arguments[1];
    return Object.keys(obj).forEach(function (componentId) {
      searchState[componentId] = _extends({}, searchState[componentId], key ? _defineProperty({}, key, obj[componentId]) : obj[componentId]);
    });
  };

  populateState(props);
  Object.keys(selectedValues).forEach(function (componentId) {
    var componentState = searchState[componentId];
    var selectedValue = selectedValues[componentId];

    if (selectedValue) {
      searchState[componentId] = _extends({}, componentState, _extends({
        title: selectedValue.label,
        componentType: selectedValue.componentType,
        value: selectedValue.value
      }, selectedValue.category && {
        category: selectedValue.category
      }, {
        URLParams: selectedValue.URLParams
      }));
    }
  });

  if (!forHeaders) {
    populateState(queryLog);
    populateState(hits, 'hits');
    populateState(aggregations, 'aggregations');
    populateState(isLoading, 'isLoading');
    populateState(error, 'error');
    populateState(promotedResults, 'promotedData');
    populateState(settings, 'settings');
    populateState(customData, 'customData');
    populateState(rawData, 'rawData');
    computeResultStats(hits, searchState, promotedResults);
  }

  populateState(dependencyTree, 'react');
  return searchState;
};

var updateInternalQuery = exports.updateInternalQuery = function updateInternalQuery(componentId, queryOptions, value, props, defaultQueryToExecute, queryParams) {
  var defaultQuery = props.defaultQuery;
  var defaultQueryOptions = void 0;
  var query = void 0;

  if (defaultQuery) {
    var queryTobeSet = defaultQuery(value, props);

    var _ref3 = queryTobeSet || {};

    query = _ref3.query;
    defaultQueryOptions = getOptionsFromQuery(queryTobeSet);
    updateDefaultQuery(componentId, props, value);
  }

  props.setQueryOptions(componentId, _extends({}, defaultQueryOptions, queryOptions || defaultQueryToExecute));

  if (query) {
    props.updateQuery(_extends({
      componentId: componentId,
      query: query,
      value: value
    }, queryParams));
  }
};

var extractQueryFromDefaultQuery = function extractQueryFromDefaultQuery(props, value) {
  var queryToBeReturned = {};
  var defaultQuery = props.defaultQuery;

  if (defaultQuery) {
    var evaluateQuery = defaultQuery(value, props);

    if (evaluateQuery) {
      var query = evaluateQuery.query,
          options = _objectWithoutProperties(evaluateQuery, ['query']);

      if (options) {
        queryToBeReturned = options;
      }
    }
  }

  return queryToBeReturned;
};

exports.extractQueryFromDefaultQuery = extractQueryFromDefaultQuery;

var getAggsQuery = exports.getAggsQuery = function getAggsQuery(value, query, props) {
  var clonedQuery = query;
  var dataField = props.dataField,
      size = props.size,
      sortBy = props.sortBy,
      showMissing = props.showMissing,
      missingLabel = props.missingLabel;
  clonedQuery.size = 0;
  clonedQuery.aggs = _defineProperty({}, dataField, {
    terms: _extends({
      field: dataField,
      size: size,
      order: getAggsOrder(sortBy || 'count')
    }, showMissing ? {
      missing: missingLabel
    } : {})
  });

  if (props.nestedField) {
    clonedQuery.aggs = {
      reactivesearch_nested: {
        nested: {
          path: props.nestedField
        },
        aggs: clonedQuery.aggs
      }
    };
  }

  return _extends({}, clonedQuery, extractQueryFromDefaultQuery(props, value));
};

var getCompositeAggsQuery = exports.getCompositeAggsQuery = function getCompositeAggsQuery() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$query = _ref4.query,
      query = _ref4$query === undefined ? {} : _ref4$query,
      props = _ref4.props,
      _ref4$after = _ref4.after,
      after = _ref4$after === undefined ? null : _ref4$after,
      _ref4$showTopHits = _ref4.showTopHits,
      showTopHits = _ref4$showTopHits === undefined ? false : _ref4$showTopHits,
      value = _ref4.value;

  var clonedQuery = query;
  var dataField = props.dataField,
      size = props.size,
      sortBy = props.sortBy,
      showMissing = props.showMissing,
      aggregationField = props.aggregationField;
  var finalField = aggregationField || dataField;
  var order = sortBy === 'count' ? {} : {
    order: sortBy
  };
  clonedQuery.aggs = _defineProperty({}, finalField, _extends({
    composite: _extends({
      sources: [_defineProperty({}, finalField, {
        terms: _extends({
          field: finalField
        }, order, showMissing ? {
          missing_bucket: true
        } : {})
      })],
      size: size
    }, after)
  }, showTopHits ? {
    aggs: _defineProperty({}, finalField, {
      top_hits: {
        size: 1
      }
    })
  } : {}));
  clonedQuery.size = 0;

  if (props.nestedField) {
    clonedQuery.aggs = {
      reactivesearch_nested: {
        nested: {
          path: props.nestedField
        },
        aggs: clonedQuery.aggs
      }
    };
  }

  return _extends({}, clonedQuery, extractQueryFromDefaultQuery(props, value));
};

var withClickIds = exports.withClickIds = function withClickIds() {
  var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return results.map(function (result, index) {
    return _extends({}, result, {
      _click_id: index
    });
  });
};

function getResultStats(props) {
  var total = props.total,
      size = props.size,
      time = props.time,
      hidden = props.hidden,
      promotedResults = props.promotedResults;
  return _extends({
    numberOfResults: total
  }, size > 0 ? {
    numberOfPages: Math.ceil(total / size)
  } : null, {
    time: time,
    hidden: hidden,
    promoted: promotedResults && promotedResults.length
  });
}

function handleOnSuggestions(results, currentValue, props) {
  var parseSuggestion = props.parseSuggestion,
      promotedResults = props.promotedResults,
      enablePredictiveSuggestions = props.enablePredictiveSuggestions;
  var fields = void 0;

  if (props.dataField) {
    fields = Array.isArray(props.dataField) ? props.dataField : [props.dataField];
  } else if (results && Array.isArray(results) && results.length > 0 && results[0] && results[0]._source) {
    fields = Object.keys(results[0]._source);
  }

  var newResults = parseHits(results, false);
  var parsedPromotedResults = parseHits(promotedResults, false);

  if (parsedPromotedResults && parsedPromotedResults.length) {
    var ids = parsedPromotedResults.map(function (item) {
      return item._id;
    }).filter(Boolean);

    if (ids) {
      newResults = newResults.filter(function (item) {
        return !ids.includes(item._id);
      });
    }

    newResults = [].concat(_toConsumableArray(parsedPromotedResults), _toConsumableArray(newResults));
  }

  var parsedSuggestions = (0, _suggestions2.default)({
    fields: fields,
    suggestions: newResults,
    currentValue: currentValue.toLowerCase(),
    showDistinctSuggestions: props.showDistinctSuggestions,
    enablePredictiveSuggestions: enablePredictiveSuggestions,
    enableSynonyms: props.enableSynonyms
  });

  if (parseSuggestion) {
    return parsedSuggestions.map(function (suggestion) {
      return parseSuggestion(suggestion);
    });
  }

  return parsedSuggestions;
}

var getTopSuggestions = exports.getTopSuggestions = function getTopSuggestions(querySuggestions) {
  var currentValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var showDistinctSuggestions = arguments[2];
  var parsedSuggestions = parseHits(querySuggestions, false);
  var finalSuggestions = (0, _suggestions2.default)({
    fields: ['key', 'key.autosuggest', 'key.search'],
    suggestions: parsedSuggestions || [],
    currentValue: currentValue.toLowerCase(),
    showDistinctSuggestions: showDistinctSuggestions
  });
  return withClickIds(finalSuggestions);
};